import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DatePipe } from '@angular/common';

@Injectable()
export class TimezoneInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Clone the request to handle the request body
    let body = req.body;

    if (typeof body === 'string') {
      try {
        body = JSON.parse(body);
        body = this.convertDatesToUTC(body);
        body = JSON.stringify(body);
      } catch (e) {
        // If parsing fails, keep the original body
      }
    } else {
      body = this.convertDatesToUTC(body);
    }

    const clonedRequest = req.clone({ body });
    return next.handle(clonedRequest).pipe(
      map((event) => {
        if (event instanceof HttpResponse) {
          // Handle response body if it exists
          event = event.clone({
            body: this.convertDatesToLocalTime(event.body),
          });
        }
        return event;
      })
    );
  }

  //#region Output Date
  private convertDatesToUTC(body: any): any {
    if (!body || typeof body !== 'object') {
      return body;
    }
    for (const key of Object.keys(body)) {
      if (body[key] instanceof Date) {
        body[key] = this.formatDateTimeZoneForOutput(body[key],"yyyy-MM-ddTHH:mm:ss.SSS'Z'");
      } else if (typeof body[key] === 'string' && this.isDate(body[key])) {
        body[key] = this.formatDateTimeZoneForOutput(body[key],"yyyy-MM-ddTHH:mm:ss.SSS'Z'");
      } else if (typeof body[key] === 'object') {
        body[key] = this.convertDatesToUTC(body[key]);
      }
    }
    return body;
  }

  formatDateTimeZoneForOutput(date: any, dateFromat: string): string {
    var dateValue = new Date(date);
    var dateFormated: string | null;

    if (dateValue.valueOf()) {
      var millis = dateValue.getTime() - new Date().getTimezoneOffset() * 60000;
      dateValue.setTime(millis);
      var datePipe = new DatePipe('en-EG');
      dateFormated = datePipe.transform(dateValue, dateFromat, 'UTC');
    }
    return dateFormated!;
  }

  private isDate(value: any): boolean {
    const iso8601Pattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{1,3})?Z$/;
    // Check if the value matches the ISO 8601 pattern
    return iso8601Pattern.test(value);
  }
  //#endregion

  //#region Input Date
  private convertDatesToLocalTime(body: any): any {
    if (!body || typeof body !== 'object') {
      return body;
    }

    for (const key of Object.keys(body)) {
      const value = body[key];
      if (typeof value === 'string' && this.isISODateString(value)) {
        // Convert ISO string to Date object in local time
        body[key] = this.formatDateTimeZoneForInput(value, "yyyy-MM-ddTHH:mm:ss.SSS'Z'");
      } else if (typeof value === 'object') {
        // Recursively apply conversion
        this.convertDatesToLocalTime(value);
      }
    }
    return body;
  }

  formatDateTimeZoneForInput(date: any, dateFromat: string): string {
    var dateValue = new Date(date);
    var dateFormated: string | null;

    if (dateValue.valueOf()) {
      var datePipe = new DatePipe('en-EG');
      dateFormated = datePipe.transform(dateValue, dateFromat, 'UTC');
    }
    return dateFormated!;
  }

  private isISODateString(value: string): boolean {
    // Check if the string is in ISO 8601 format
    const isoDateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?Z$/;
    

    return isoDateRegex.test(value);
  }
  //#endregion
  
}
